/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pxk_SubmitInputs */

const vi_pl_pxk_submit = /** @type {(inputs: Pl_Pxk_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu`)
};

/**

* @param {Pl_Pxk_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pxk_submit = /** @type {((inputs?: Pl_Pxk_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pxk_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pxk_submit(inputs)
});